<template>
  <div class="orders-summary_container width-responsiveness">
    <div class="orders-summary__items">
      <orders-summary-status
        :value="correctOrders"
        name="corretas"
        type="correct"
      />
      <orders-summary-status
        :value="modifiedOrders"
        name="corrigidas"
        type="fixed"
      />
      <orders-summary-status
        :value="errorOrders"
        name="erros"
        type="error"
      />
      <div class="orders-summary__status">
        <div class="orders-summary__status__label total-label">
          total:
          <span id="totalOs">{{ total }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrdersSummaryStatus from './OrdersSummaryStatus'
import { mapGetters } from 'vuex'
export default {
  name: 'OrdersSummary',
  components: {
    OrdersSummaryStatus
  },
  data: () => ({
    total: 0
  }),
  computed: {
    ...mapGetters(['correctOrders', 'errorOrders', 'modifiedOrders'])
  },
  watch: {
    correctOrders: function (newValue) {
      this.getTotal()
    },
    errorOrders: function (newValue) {
      this.getTotal()
    },
    modifiedOrders: function (newValue) {
      this.getTotal()
    }
  },
  methods: {
    getTotal() {
      this.total = parseInt(this.correctOrders) + parseInt(this.modifiedOrders) + parseInt(this.errorOrders)
    }
  }
}
</script>
<style lang="scss" scoped>
  .orders-summary_container {
    font-size: 12px;
    color: #7a7a7a;
    font-weight: 400;
    margin-top: 5px;
    margin-bottom: 15px;
    flex-direction: row;
    display: flex;
    width: 100%;

    .orders-summary {
      &__title {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.08;
        color: #7a7a7a;
        margin-left: 30px;
        margin-bottom: 6px;
        letter-spacing: 1px;
      }
      &__items {
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
